import type { Notification } from 'entities/notification';

export const isNotificationNew = (notification: Notification) => {
  return notification.attributes.isNew;
};
